import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginModule } from './login/login.module';
import { ScannerModule } from './scanner/scanner.module';
import { InventoryModule } from './inventory/inventory.module';
import { MaterialsModule } from './materials/materials.module';
import { UsersModule } from './users/users.module';
import {ReportsModule} from './reports/reports.module';
import { RemnantsModule } from './remnants/remnants.module';

import { AuthService } from './shared/services/auth.service';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { DenyStaffService } from './shared/services/deny-staff.service';
import { DenyNonStaffService } from './shared/services/deny-non-staff.service';
import { AppService } from './shared/services/app.service';
import { NotifyService } from './shared/services/notify.service';

import { AppComponent } from './app.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { BgComponent } from './bg/bg.component';
import { NotifyComponent } from './notify/notify.component';
import {DatePipe} from '@angular/common';


@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    MainNavComponent,
    BgComponent,
    NotifyComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot([
      { path: 'welcome', component: WelcomeComponent, canActivate: [AuthGuardService, DenyStaffService, DenyNonStaffService] },
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },
      { path: '**', redirectTo: 'welcome', pathMatch: 'full' }
    ]),
    LoginModule,
    ScannerModule,
    InventoryModule,
    MaterialsModule,
    UsersModule,
    RemnantsModule,
    ReportsModule,
    NgbModule.forRoot()
  ],
  providers: [
    AuthService,
    AuthGuardService,
    DenyStaffService,
    DenyNonStaffService,
    AppService,
    NotifyService,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts